var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0042 6.81624C16.2048 7.01618 16.2054 7.34092 16.0055 7.54157L10.3997 13.1674C10.1792 13.3887 9.82087 13.3886 9.60038 13.1674L3.99458 7.54157C3.79464 7.34092 3.79522 7.01618 3.99587 6.81624C4.19652 6.6163 4.52126 6.61688 4.7212 6.81753L10 12.1152L15.2789 6.81753C15.4788 6.61688 15.8035 6.6163 16.0042 6.81624Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1316 6.67073C15.4127 6.38868 15.8692 6.3873 16.1513 6.66829C16.4335 6.94944 16.4341 7.40665 16.1529 7.6888L10.5475 13.3146C10.2456 13.6175 9.75483 13.6174 9.45291 13.3146L3.84663 7.6888C3.56557 7.40664 3.56695 6.94941 3.84907 6.66829C4.13125 6.38745 4.58772 6.38868 4.86877 6.67073L9.99979 11.8188L15.1316 6.67073ZM15.8567 6.9637C15.7376 6.84524 15.5449 6.84546 15.4262 6.96452L10.1479 12.2624C10.1088 12.3016 10.0552 12.3234 9.99979 12.3234C9.94453 12.3233 9.89152 12.3015 9.85249 12.2624L4.57336 6.96452C4.45463 6.84554 4.26195 6.84506 4.14286 6.9637C4.02378 7.08236 4.02353 7.27504 4.14204 7.3942L9.74832 13.02C9.88739 13.1596 10.113 13.1596 10.2521 13.02L15.8575 7.3942C15.9763 7.27506 15.9759 7.08243 15.8567 6.9637Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.eaa59cc9b9ff4ffa3d96043f8c277cbb.svg";
export { ForwardRef as ReactComponent };